import { apiClient } from '../client'
import type { IpApiResponse, IpDetailsType } from '../../app/modules/types/ip'
import type { BulkOwnerBody, BulkResponse } from '../../app/modules/types/issues'
import { OWNS_ERRORS } from '../ownsErrors'
import type { OptionsType } from '../../app/modules/types/filters'
/**
 * IPs API endpoints
 */
export const ipsApi = {
  /** Set (or clear, with `owner: null`) the owner of many IPs at once. */
  bulkOwner: async (body: BulkOwnerBody): Promise<BulkResponse> => {
    const { data } = await apiClient.post('/ip/bulk-owner/', body, OWNS_ERRORS)
    return data
  },

  /**
   * Get IPs list
   */
  getList: async (params?: string): Promise<IpApiResponse> => {
    const url = params ? `/ip/?${params}` : '/ip/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get IP by ID
   */
  getById: async (ipId: string, customScanIds?: string): Promise<IpDetailsType> => {
    const url = customScanIds
      ? `/ip/${ipId}/?custom_scan_ids=${customScanIds}`
      : `/ip/${ipId}/`
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get IP statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/ip/stats/')
    return data
  },

  /**
   * Get IP filter options
   */
  getFilterOptions: async (): Promise<OptionsType> => {
    const { data } = await apiClient.get('/ip/filter/')
    return data
  },
}
